import { SET_MAKES_DATA } from 'js/store/makes/Makes.actions.js';

import { parseData } from 'js/store/makes/Makes.parser.js';

const initState = {
  makeIds: [],
  makesById: {},
};

const makes = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_MAKES_DATA: {
      const { makesById, makeIds } = parseData(action.payload);
      nextState.makeIds = makeIds;
      nextState.makesById = makesById;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default makes;
